import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { City } from "../api"

export const GLOBAL_SENTINEL = "global";

type CityState = {
  cities: City[]
  selectedCityId: string | null
  isLoading: boolean
  setCities: (cities: City[]) => void
  setSelectedCityId: (id: string | null) => void
  setLoading: (loading: boolean) => void
}

export const useCityStore = create<CityState>()(
  persist(
    (set) => ({
      cities: [],
      selectedCityId: null,
      isLoading: false,
      setCities: (cities) => set({ cities }),
      setSelectedCityId: (selectedCityId) => set({ selectedCityId }),
      setLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'trotroways-admin-city-v1',
      partialize: (state) => ({ selectedCityId: state.selectedCityId }),
    }
  )
)

export const useIsGlobal = () => {
  const selectedCityId = useCityStore((state) => state.selectedCityId)
  return selectedCityId === GLOBAL_SENTINEL;
};

export const useSelectedCity = () => {
  const cities = useCityStore((state) => state.cities)
  const selectedCityId = useCityStore((state) => state.selectedCityId)
  if (selectedCityId === GLOBAL_SENTINEL) return null;
  return cities.find((c) => c.id === selectedCityId) || null;
};
